import React from 'react';
import PropTypes from 'prop-types';
import ModalV4 from "../../../app/ui/modal/v4/v4";

import ModalV4Header from "../../../app/ui/modal/v4/header/v4-header";
import ModalOptionsSelection from "../../gd-components/modal-options-selection/modal-options-selection-new";
import ViewTemplates from "../../manager/view-templates/view-templates";
import {ViewTypeConfigs} from "../../gd/const/views/view-type-config";

module.exports = class ModalLoadViewTemplate extends ModalV4 {

    static propTypes = {
        params: PropTypes.shape({
            // companyId: PropTypes.string.isRequired,
            systemType: PropTypes.any,
            onSubmit: PropTypes.func.isRequired
        }),
    };

    constructor(props) {
        super(props);

        const layoutViewTemplates = new ViewTemplates();
        this.templates = layoutViewTemplates.getViewTemplates(this.props.params.systemType);
    }

    onSelectTemplate = (templateId) => {
        const viewTemplate = _.find(this.templates, template => template.id === templateId);
        this.props.params.onSubmit(viewTemplate)
    }

    onEditTemplate = (templateId) => {
        const layoutViewTemplates = new ViewTemplates(gd.companyId);
        const template = _.find(layoutViewTemplates.getViewTemplates(this.props.params.systemType), template=>template.id === templateId);

        gd.modals.editViewTemplate(template.name, template.access, this.props.params.systemType, values=>{
            layoutViewTemplates.editTemplate(templateId, values.name, values.access, this.props.params.systemType);
        });
    }

    onDeleteTemplate = (templateId) => {
        const layoutViewTemplates = new ViewTemplates(gd.companyId);
        const template = _.find(layoutViewTemplates.getViewTemplates(this.props.params.systemType), template=>template.id === templateId);

        const message = (
            <div className="message">
                <div className="txt">Are you sure that you want to delete </div>
                <div className="highlight">{template.name}</div>
                <div className="txt">template?</div>
            </div>
        );

        gd.modals.confirm.deleteMessage('template',message,()=>{
            const layoutViewTemplates = new ViewTemplates(gd.companyId);
            layoutViewTemplates.removeTemplate(templateId);
            gd.modal.hide();
        });
    }

    render() {
        const isManager = gd.ac.check.company.isManager((gd.companyId));

        return (
            <div className="v4-container placement-middle" onClick={this.stopPropagation}>

                <ModalV4Header height={60} title="Load view from template" />

                {this.templates.length > 0 &&
                <ModalOptionsSelection ref={r => this.modalOptionsSelection = r}
                                       className="form-container"
                                       options={this.templates.map(t=>({
                                           id:t.id,
                                           label:t.name,
                                           showLock: t.access === 'private',
                                           icon: ViewTypeConfigs[t.viewSystemType].icon,
                                           editable: isManager || t.userId === gd.session.me.id
                                       }))}
                                       onSelectOption={this.onSelectTemplate}
                                       onEditOption={this.onEditTemplate}
                                       onDeleteOption={this.onDeleteTemplate}/>}

                {this.templates.length === 0 && <div className="no-items-found">No templates found</div>}
            </div>
        )
    }
};